import { userRegistration } from "../../../helpers/backend_helper";

import {
  registerUserSuccessful,
  registerUserFailed,
  loadingData,
} from "./reducer";

export const registerUser = (user) => async (dispatch) => {
  try {
    dispatch(loadingData(true));
    let response;
    response = userRegistration(user);

    const data = await response;

    // if (data.message === "success") {
    dispatch(registerUserSuccessful(data));
    // } else {
    //   dispatch(registerUserFailed(data));
    // }
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data;
    if (errorMessage?.email) {
      dispatch(registerUserFailed(errorMessage.email[0]));
    } else {
      dispatch(registerUserFailed("Please to Register Again"));
    }
  } finally {
    dispatch(loadingData(false));
  }
};
